<template>
  <scroll-right-frame>
    <div class="invoice-stats-container">
    <!-- 筛选控制区 -->
    <el-card class="filter-card" shadow="never">
      <div class="filter-panel">
        <!-- 第一行：筛选条件 -->
        <el-row :gutter="20" class="filter-row">
          <el-col :span="7">
            <div class="filter-item">
              <label class="filter-label">日期范围：</label>
              <el-date-picker
                v-model="filters.dateRange"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                @change="onDateRangeChange">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="filter-item">
              <label class="filter-label">产品线：</label>
              <el-select
                v-model="filters.productLineIds"
                multiple
                placeholder="请选择产品线"
                clearable
                collapse-tags
                @change="onFilterChange">
                <el-option
                  v-for="item in filterOptions.productLines"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="filter-item">
              <label class="filter-label">服务商：</label>
              <el-select
                v-model="filters.providers"
                multiple
                placeholder="请选择服务商"
                clearable
                collapse-tags
                @change="onFilterChange">
                <el-option
                  v-for="item in filterOptions.providers"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="filter-item">
              <label class="filter-label">接口类型：</label>
              <el-select
                v-model="filters.methodTypes"
                multiple
                placeholder="请选择接口类型"
                clearable
                collapse-tags
                @change="onFilterChange">
                <el-option
                  v-for="item in filterOptions.methodTypes"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </div>
          </el-col>
        </el-row>

        <!-- 第二行：操作按钮 -->
        <el-row :gutter="20" class="button-row">
          <el-col :span="24" class="filter-buttons">
            <el-button type="primary" icon="el-icon-search" @click="loadChartsData">查询</el-button>
            <el-button icon="el-icon-refresh" @click="resetFilters">重置</el-button>
            <el-button
              type="success"
              icon="el-icon-refresh-right"
              :loading="loading"
              @click="refreshData">
              刷新数据
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-card>

    <!-- 统计卡片区 -->
    <el-row :gutter="20" class="stats-cards">
      <el-col :span="6">
        <el-card class="stats-card" shadow="hover">
          <div class="stats-item">
            <div class="stats-icon total-icon">
              <i class="el-icon-s-data"></i>
            </div>
            <div class="stats-content">
              <div class="stats-value">{{ formatNumber(overview.totalCalls) }}</div>
              <div class="stats-label">
                总调用次数
                <el-tooltip placement="top" effect="light">
                  <div slot="content" style="max-width: 250px;">
                    所选时间范围和筛选条件下，<br/>
                    发票接口的累计调用次数总和
                  </div>
                  <i class="el-icon-question stats-help-icon"></i>
                </el-tooltip>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stats-card" shadow="hover">
          <div class="stats-item">
            <div class="stats-icon success-icon">
              <i class="el-icon-circle-check"></i>
            </div>
            <div class="stats-content">
              <div class="stats-value">{{ formatNumber(overview.successCalls) }}</div>
              <div class="stats-label">
                成功调用
                <el-tooltip placement="top" effect="light">
                  <div slot="content" style="max-width: 250px;">
                    调用成功的次数，<br/>
                    即接口返回成功状态的调用数量
                  </div>
                  <i class="el-icon-question stats-help-icon"></i>
                </el-tooltip>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stats-card" shadow="hover">
          <div class="stats-item">
            <div class="stats-icon rate-icon">
              <i class="el-icon-pie-chart"></i>
            </div>
            <div class="stats-content">
              <div class="stats-value">{{ overview.successRate }}%</div>
              <div class="stats-label">
                成功率
                <el-tooltip placement="top" effect="light">
                  <div slot="content" style="max-width: 250px;">
                    成功调用次数 ÷ 总调用次数 × 100%<br/>
                    反映发票接口的稳定性
                  </div>
                  <i class="el-icon-question stats-help-icon"></i>
                </el-tooltip>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stats-card" shadow="hover">
          <div class="stats-item">
            <div class="stats-icon customer-icon">
              <i class="el-icon-user"></i>
            </div>
            <div class="stats-content">
              <div class="stats-value">{{ overview.activeCustomers }}</div>
              <div class="stats-label">
                活跃客户数
                <el-tooltip placement="top" effect="light">
                  <div slot="content" style="max-width: 250px;">
                    所选时间范围和筛选条件下，<br/>
                    有使用记录的客户总数
                  </div>
                  <i class="el-icon-question stats-help-icon"></i>
                </el-tooltip>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 图表区域 -->
    <el-row :gutter="20" class="charts-row">
      <el-col :span="8">
        <el-card class="chart-card" shadow="never">
          <div slot="header" class="chart-header">
            <span>服务商分布</span>
            <el-tooltip placement="top" effect="light">
              <div slot="content" style="max-width: 300px;">
                <strong>功能说明：</strong><br/>
                展示各个发票服务商的调用量占比，包括：<br/>
                • 诺诺发票<br/>
                • 博思发票<br/>
                • 其他服务商
              </div>
              <i class="el-icon-question chart-help-icon"></i>
            </el-tooltip>
          </div>
          <provider-pie-chart :data="providerStats" :loading="loading" />
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="chart-card" shadow="never">
          <div slot="header" class="chart-header">
            <span>接口类型分布</span>
            <el-tooltip placement="top" effect="light">
              <div slot="content" style="max-width: 300px;">
                <strong>功能说明：</strong><br/>
                展示不同接口类型的调用量分布，包括：<br/>
                • 开票类接口<br/>
                • 查询类接口<br/>
                • 红冲类接口<br/>
                • 其他接口
              </div>
              <i class="el-icon-question chart-help-icon"></i>
            </el-tooltip>
          </div>
          <method-type-pie-chart :data="methodTypeStats" :loading="loading" />
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="chart-card" shadow="never">
          <div slot="header" class="chart-header">
            <span>Top10 客户排行</span>
            <el-tooltip placement="top" effect="light">
              <div slot="content" style="max-width: 300px;">
                <strong>功能说明：</strong><br/>
                按调用次数统计使用量最高的前10个客户，<br/>
                帮助了解主要客户的使用情况。
              </div>
              <i class="el-icon-question chart-help-icon"></i>
            </el-tooltip>
          </div>
          <top-customers-chart :data="topCustomers" :loading="loading" />
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="charts-row">
      <el-col :span="24">
        <el-card class="chart-card" shadow="never">
          <div slot="header" class="chart-header">
            <div class="chart-title-wrapper">
              <span>调用趋势图</span>
              <el-tooltip placement="top" effect="light">
                <div slot="content" style="max-width: 300px;">
                  <strong>功能说明：</strong><br/>
                  展示所选时间范围内每日的调用量和成功率变化趋势，<br/>
                  柱状图显示调用次数，折线图显示成功率。<br/>
                  <em>注意：跨年数据会显示完整日期（年-月-日）</em>
                </div>
                <i class="el-icon-question chart-help-icon"></i>
              </el-tooltip>
            </div>
          </div>
          <trend-line-chart
            :data="dailyTrend"
            :loading="loading" />
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="charts-row">
      <el-col :span="24">
        <el-card class="chart-card" shadow="never">
          <div slot="header" class="chart-header">
            <span>产品线分布</span>
            <el-tooltip placement="top" effect="light">
              <div slot="content" style="max-width: 300px;">
                <strong>功能说明：</strong><br/>
                柱状图展示各产品线的调用次数，<br/>
                折线图展示各产品线的成功率，<br/>
                帮助了解不同产品线的使用情况和接口稳定性。
              </div>
              <i class="el-icon-question chart-help-icon"></i>
            </el-tooltip>
          </div>
          <product-line-chart :data="productLineStats" :loading="loading" />
        </el-card>
      </el-col>
    </el-row>

    </div>
  </scroll-right-frame>
</template>

<script>
import util from '../../../../libs/util'
import ScrollRightFrame from '../../../../components/scroll-right-frame.vue'
import ProviderPieChart from './components/provider-pie-chart.vue'
import MethodTypePieChart from './components/method-type-pie-chart.vue'
import TopCustomersChart from './components/top-customers-chart.vue'
import TrendLineChart from './components/trend-line-chart.vue'
import ProductLineChart from './components/product-line-chart.vue'

export default {
  name: 'InvoiceStats',
  components: {
    ScrollRightFrame,
    ProviderPieChart,
    MethodTypePieChart,
    TopCustomersChart,
    TrendLineChart,
    ProductLineChart
  },
  data() {
    return {
      loading: false,

      // 筛选条件
      filters: {
        dateRange: [],
        productLineIds: [],
        providers: [],
        methodTypes: []
      },

      // 筛选选项
      filterOptions: {
        productLines: [],
        providers: [],
        methodTypes: []
      },

      // 日期选择器配置
      pickerOptions: {
        shortcuts: [{
          text: '本月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setDate(1)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一周',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近半年',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一年',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365)
            picker.$emit('pick', [start, end])
          }
        }]
      },

      // 图表数据
      overview: {
        totalCalls: 0,
        successCalls: 0,
        successRate: 0,
        activeCustomers: 0
      },
      providerStats: [],
      methodTypeStats: [],
      topCustomers: [],
      dailyTrend: [],
      productLineStats: []
    }
  },

  created() {
    this.initFilters()
    this.loadFilterOptions()
    this.loadChartsData()
  },

  methods: {
    /**
     * 初始化筛选条件
     */
    initFilters() {
      // 默认选中本月
      const end = new Date()
      const start = new Date()
      start.setDate(1)

      this.filters.dateRange = [
        this.formatDate(start),
        this.formatDate(end)
      ]
    },

    /**
     * 加载筛选选项
     */
    async loadFilterOptions() {
      try {
        const response = await util.ajax.get('/entity/stats/invoice/filter-options')
        if (response.data.meta.errCode === 0) {
          this.filterOptions = response.data.data
        }
      } catch (error) {
        this.$message.error('加载筛选选项失败: ' + error.message)
      }
    },

    /**
     * 加载图表数据
     */
    async loadChartsData() {
      if (this.loading) return

      this.loading = true
      try {
        const params = {
          startDate: this.filters.dateRange[0],
          endDate: this.filters.dateRange[1],
          productLineIds: this.filters.productLineIds,
          providers: this.filters.providers,
          methodTypes: this.filters.methodTypes
        }

        const response = await util.ajax.post('/entity/stats/invoice/charts', params)
        if (response.data.meta.errCode === 0) {
          const data = response.data.data
          console.log('=== 接收到的发票统计数据 ===', data)

          this.overview = data.overview || {}
          this.providerStats = data.providerStats || []
          this.methodTypeStats = data.methodTypeStats || []
          this.topCustomers = data.topCustomers || []
          this.dailyTrend = data.dailyTrend || []
          this.productLineStats = data.productLineStats || []

          console.log('处理后的数据:', {
            overview: this.overview,
            providerStats: this.providerStats,
            methodTypeStats: this.methodTypeStats,
            topCustomers: this.topCustomers,
            dailyTrend: this.dailyTrend,
            productLineStats: this.productLineStats
          })
        } else {
          this.$message.error('加载数据失败: ' + response.data.meta.errMsg)
        }
      } catch (error) {
        this.$message.error('加载数据失败: ' + error.message)
      } finally {
        this.loading = false
      }
    },

    /**
     * 重置筛选条件
     */
    resetFilters() {
      this.filters.productLineIds = []
      this.filters.providers = []
      this.filters.methodTypes = []
      this.initFilters()
      this.loadChartsData()
    },

    /**
     * 刷新数据
     */
    refreshData() {
      this.loadChartsData()
    },

    /**
     * 日期范围改变
     */
    onDateRangeChange(dateRange) {
      if (dateRange && dateRange.length === 2) {
        this.loadChartsData()
      }
    },

    /**
     * 筛选条件改变
     */
    onFilterChange() {
      this.loadChartsData()
    },

    /**
     * 格式化日期
     */
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },

    /**
     * 格式化数字
     */
    formatNumber(num) {
      if (num === undefined || num === null) return '0'
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  }
}
</script>

<style scoped>
/* ========== 容器样式 ========== */
.invoice-stats-container {
  padding: 0 10px 0 0;
  background: linear-gradient(to bottom, #f5f7fa 0%, #ffffff 100%);
  min-height: 100vh;
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
}

/* ========== 防止横向滚动 ========== */
.el-row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.el-col {
  padding-left: 10px !important;
  padding-right: 10px !important;
}

/* ========== 筛选卡片 ========== */
.filter-card {
  margin-bottom: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
  border: none;
  overflow: hidden;
  transition: all 0.3s ease;
  max-width: 100%;
  box-sizing: border-box;
}

.filter-card:hover {
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.12);
}

.filter-card /deep/ .el-card__body {
  padding: 24px;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
}

.filter-panel {
  padding: 0;
}

.filter-row {
  margin-bottom: 0 !important;
}

.filter-item {
  display: flex;
  align-items: center;
  width: 100%;
}

.filter-label {
  flex-shrink: 0;
  width: 90px;
  font-weight: 600;
  color: #303133;
  text-align: right;
  padding-right: 12px;
  font-size: 14px;
}

.filter-item .el-select,
.filter-item .el-date-picker {
  flex: 1;
}

.button-row {
  margin-top: 16px !important;
  padding-top: 16px;
  border-top: 1px solid #ebeef5;
}

.filter-buttons {
  text-align: left;
}

.filter-buttons .el-button {
  border-radius: 8px;
  padding: 10px 20px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.filter-buttons .el-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
}

/* ========== 统计卡片 ========== */
.stats-cards {
  margin-bottom: 24px;
}

.stats-card {
  border-radius: 16px;
  border: none;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
  position: relative;
  max-width: 100%;
  box-sizing: border-box;
}

.stats-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.stats-card:hover::before {
  opacity: 1;
}

.stats-card:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.15);
}

.stats-card /deep/ .el-card__body {
  padding: 24px;
  background: white;
}

.stats-item {
  display: flex;
  align-items: center;
  padding: 8px 0;
}

.stats-icon {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  font-size: 28px;
  color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  animation: iconPulse 2s ease-in-out infinite;
}

.stats-card:hover .stats-icon {
  transform: rotate(5deg) scale(1.1);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

@keyframes iconPulse {
  0%, 100% {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
  50% {
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
  }
}

.total-icon {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.success-icon {
  background: linear-gradient(135deg, #67c23a 0%, #85ce61 100%);
}

.rate-icon {
  background: linear-gradient(135deg, #4facfe 0%, #00c6fb 100%);
}

.customer-icon {
  background: linear-gradient(135deg, #5daf7f 0%, #4ab8a8 100%);
}

.stats-content {
  flex: 1;
  min-width: 0;
}

.stats-value {
  font-size: 28px;
  font-weight: 700;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 8px;
  letter-spacing: -0.5px;
  animation: valueSlideIn 0.6s ease-out;
}

@keyframes valueSlideIn {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.stats-label {
  font-size: 13px;
  color: #909399;
  font-weight: 500;
  letter-spacing: 0.3px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.stats-help-icon {
  font-size: 14px;
  color: #c0c4cc;
  cursor: help;
  transition: all 0.3s ease;
}

.stats-help-icon:hover {
  color: #667eea;
  transform: scale(1.15);
}

/* ========== 图表卡片 ========== */
.charts-row {
  margin-bottom: 24px;
}

.chart-card {
  border-radius: 16px;
  border: none;
  box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  background: white;
  max-width: 100%;
  box-sizing: border-box;
}

.chart-card:hover {
  box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.12);
  transform: translateY(-4px);
}

.chart-card /deep/ .el-card__header {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-bottom: 2px solid #e4e7ed;
  padding: 20px 24px;
}

.chart-card /deep/ .el-card__body {
  padding: 20px;
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
  color: #303133;
}

.chart-header span {
  display: flex;
  align-items: center;
  gap: 8px;
}

.chart-header span::before {
  content: '';
  display: inline-block;
  width: 4px;
  height: 18px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 2px;
}

.chart-title-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.chart-help-icon {
  font-size: 16px;
  color: #909399;
  cursor: help;
  transition: all 0.3s ease;
  margin-left: 8px;
}

.chart-help-icon:hover {
  color: #667eea;
  transform: scale(1.2);
}

/* ========== 按钮美化 ========== */
.invoice-stats-container /deep/ .el-button--primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.invoice-stats-container /deep/ .el-button--primary:hover {
  background: linear-gradient(135deg, #7e8ff0 0%, #8d5bb2 100%);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.invoice-stats-container /deep/ .el-button--success {
  background: linear-gradient(135deg, #67c23a 0%, #85ce61 100%);
  border: none;
  box-shadow: 0 2px 8px rgba(103, 194, 58, 0.3);
}

.invoice-stats-container /deep/ .el-button--success:hover {
  background: linear-gradient(135deg, #85ce61 0%, #95d475 100%);
  box-shadow: 0 4px 12px rgba(103, 194, 58, 0.4);
}

/* ========== 日期选择器和下拉框美化 ========== */
.invoice-stats-container /deep/ .el-date-editor {
  border-radius: 8px;
  transition: all 0.3s ease;
}

.invoice-stats-container /deep/ .el-date-editor:hover {
  border-color: #667eea;
}

.invoice-stats-container /deep/ .el-date-editor.is-active {
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
}

.invoice-stats-container /deep/ .el-select {
  width: 100%;
}

.invoice-stats-container /deep/ .el-input__inner {
  border-radius: 8px;
  transition: all 0.3s ease;
}

.invoice-stats-container /deep/ .el-input__inner:hover {
  border-color: #667eea;
}

.invoice-stats-container /deep/ .el-input__inner:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
}

/* ========== 进入动画 ========== */
.stats-card {
  animation: cardFadeIn 0.6s ease-out backwards;
}

.stats-card:nth-child(1) { animation-delay: 0.1s; }
.stats-card:nth-child(2) { animation-delay: 0.2s; }
.stats-card:nth-child(3) { animation-delay: 0.3s; }
.stats-card:nth-child(4) { animation-delay: 0.4s; }

@keyframes cardFadeIn {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.chart-card {
  animation: chartFadeIn 0.8s ease-out backwards;
}

@keyframes chartFadeIn {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* ========== 滚动条美化 ========== */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #7e8ff0 0%, #8d5bb2 100%);
}

/* ========== 响应式设计 ========== */
@media (max-width: 1200px) {
  .stats-cards .el-col {
    margin-bottom: 16px;
  }

  .charts-row .el-col {
    margin-bottom: 24px;
  }

  .stats-value {
    font-size: 24px;
  }

  .stats-icon {
    width: 56px;
    height: 56px;
    font-size: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/custom/components/stats/invoice-stats/invoice-stats.vue